import React, { useEffect, useState } from 'react';
import NoData from '../NoData/NoData';
import Menu from './Menu';
import ItemsCarousel from 'react-items-carousel';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';


function getMenus(isRestaurant,vendor, vendorId, items, closed) {
    var itemsArray = []
    if (items?.length) {
        items.map(item =>
            itemsArray.push(<Grid item xs={12} xl={3} lg={4} md={4} sm={6}><div style={{ marginBottom: '1rem' }}><Menu vendor={vendor} closed={closed} id={item.id} vendorId={vendorId} image={item?.image} isMenu={isRestaurant} price={item?.price} description={item?.description} title={item?.name} product={item} /></div></Grid>)
        )
    } else {
        itemsArray.push(<div style={{ paddingLeft: '2rem' }}>No Record Found</div>)
    }
    
    return <Grid style={{paddingLeft: '2rem'}} container spacing={3}>{itemsArray}</Grid>
}

const Menus = ({ index, categoryId, subCategoryId, isRestaurant, vendorId,vendor, allProducts, allMenus, closed }) => {
    const [items, updateMenus] = useState([]);
    const [activeMenuIndex, setActiveMenuIndex] = useState(0);
    const chevronWidth = 40;
    useEffect(() => {
        // if (!isRestaurant) {
        const tempMenus = allProducts?.filter((item) => {
            return item.subCategoryId === subCategoryId;
        });
        updateMenus(tempMenus);
        // } else {
        //     const tempMenus = allMenus?.filter((item) => {
        //         return item.subCategoryId === subCategoryId;
        //     });
        //     updateMenus(tempMenus);
        // }

    }, [])

    const tempMenus = allProducts?.filter((item) => {
        return item.subCategoryId === subCategoryId;
    });
    return (
        <div style={{
        }} className={'row'}>
            {getMenus(isRestaurant,vendor, vendorId, tempMenus, closed)}
        </div>
    );
};


export default Menus;